define([

],function(){

	// if you need not custom methods, just use
	// return webix.remote.users;

	//hardcode user
	//webix.remote.$user = { id:1 };

	var current_user = webix.remote.$user || null;
	if (current_user)
		setCurrentUser(current_user);

	function setCurrentUser(value, afterlogin){
		//we need to reload document after login out
		if (!value){
			webix.remote.session.logout().then(function(){
				current_user = null;
				document.location.reload();	
			});
			return;
		}
		//we need to reload document when changing active user
		if (current_user && current_user != value){
			document.location.reload();
			return;
		}

		current_user = value;

		var isvalid = (current_user.settings && typeof current_user.settings == "string");
		current_user.settings = isvalid ? JSON.parse(current_user.settings) : {};

		webix.extend(current_user.settings,{
			language:"en",
			theme:"siberia:webix",
			notifications:0
		});

		function applyUserThemeSettings(afterlogin, locale, theme) {
			if (afterlogin) {
				if (!locale.isNow(current_user.settings.language) ||
				    !theme.isNow(current_user.settings.theme))
				    	document.location.reload();
			}

			theme.setTheme(current_user.settings.theme, afterlogin);
		}

		function loadLocaleTheme(afterlogin) {
			if (typeof require !== "undefined" && typeof require === "function" && require.toUrl) {
				require(["helpers/locale", "helpers/theme"], function (locale, theme) {
					applyUserThemeSettings(afterlogin, locale, theme);
				});
				return;
			}

			if (window.__localeModule && window.__themeModule) {
				applyUserThemeSettings(afterlogin, window.__localeModule, window.__themeModule);
			}
		}

		loadLocaleTheme(afterlogin);
	}

	function getCurrentUser(){
		return current_user;
	}

	function saveSetting(key, value, reload){
		if(current_user){
			var settings = current_user.settings;

			if(!settings[key] || value != settings[key]){
				settings[key] = value;
				if (reload)
					document.location.reload();
			}
		}
	}


	var api = {
		saveSetting:saveSetting,
		getCurrentUser:getCurrentUser,
		setCurrentUser:setCurrentUser,
	};

	if (typeof window !== "undefined")
		window.__userModule = api;

	return api;

});